function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1414_9983)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.79999 20.7L4.49999 8.50002C4.59999 7.30002 5.59999 6.40002 6.79999 6.40002H16.2C17.4 6.40002 18.4 7.30002 18.5 8.50002L19.1 20.5",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1 6.3H9.7C8.2 6.3 7 5.1 7 3.6V3.2C7 1.7 8.2 0.5 9.7 0.5H13.1C14.6 0.5 15.8 1.7 15.8 3.2V3.6C15.8 5.1 14.6 6.3 13.1 6.3Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5 20.2L18.6 20.5C18.3 20.6 18 20.8 17.8 21.1L17.2 22.9C13.4 22.4 9.49999 22.4 5.69999 22.8L4.99999 22.9L4.39999 21.1C4.19999 20.8 3.99999 20.6 3.59999 20.5L2.69999 20.2C2.09999 20 1.49999 20.3 1.19999 20.8L0.699987 21.6C0.499987 21.9 0.499987 22.2 0.599987 22.5L1.69999 27.1C1.79999 27.7 2.39999 28.1 2.99999 28.1H19.9C20.6 28.1 21.1 27.6 21.2 26.9L21.7 22.4C21.7 22.1 21.7 21.9 21.5 21.6L21 20.9C20.7 20.3 20.1 20.1 19.5 20.2Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 14.9C14 14.1 13.4 13.5 12.6 13.5H12.5C12.2 12.6 11.4 12 10.4 12C9.20001 12 8.20001 13 8.20001 14.2C8.20001 15.2 8.80001 16 9.70001 16.3V16.4C9.70001 17.2 10.4 17.9 11.2 17.9C12 17.9 12.7 17.2 12.7 16.4C13.4 16.3 14 15.7 14 14.9Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7 12.7C15.0866 12.7 15.4 12.3866 15.4 12C15.4 11.6134 15.0866 11.3 14.7 11.3C14.3134 11.3 14 11.6134 14 12C14 12.3866 14.3134 12.7 14.7 12.7Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.9 19.9C8.39706 19.9 8.8 19.497 8.8 19C8.8 18.5029 8.39706 18.1 7.9 18.1C7.40294 18.1 7 18.5029 7 19C7 19.497 7.40294 19.9 7.9 19.9Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.9 11.5C8.39706 11.5 8.8 11.097 8.8 10.6C8.8 10.1029 8.39706 9.69995 7.9 9.69995C7.40294 9.69995 7 10.1029 7 10.6C7 11.097 7.40294 11.5 7.9 11.5Z",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2 19.9L11.6 20.4",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2 15.9L13.2 18.9",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6 19.4L13.9 20.1",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 18.4L13.9 20.1",
  stroke: "#002556",
  className: "color-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1414_9983"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22.2,
  height: 28.8,
  fill: "white"
})));
function SvgIcnCapInteriorDamages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCapInteriorDamages);
export default __webpack_public_path__ + "static/media/icn-cap-interior-damages.d44f2f4cb6086a3daea3998e585b2819.svg";
export { ForwardRef as ReactComponent };